module.exports = __webpack_public_path__ + "img/Flexible Character.9acf259f.svg";